import { BrowserRouter } from "react-router-dom";
import BaseRoutes from "./routes";

import Footer from "./components/Footer";
import Header from "./components/Header";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="overflow-x-hidden min-h-screen flex flex-col">
      <div className="flex flex-col flex-grow">
        <BrowserRouter>
        <Header/>
          <BaseRoutes />
          <Footer />
          <CookieBanner/>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
